document.addEventListener("DOMContentLoaded", () => {
  const snowContainer = document.createElement("div");
  snowContainer.classList.add("snow-container");
  document.body.appendChild(snowContainer);

  const numFlakes = 70;

  for (let i = 0; i < numFlakes; i++) {
    const flake = document.createElement("div");
    flake.classList.add("flake");
    flake.style.left = `${Math.random() * 100}%`;
    flake.style.animationDelay = `${Math.random() * 10}s`;
    flake.style.opacity = `${0.2 + Math.random() * 0.8}`;
    snowContainer.appendChild(flake);
  }

  console.log("Snow script loaded!");
});
